
export enum PasswordStrength {
  Weakest,
  Weak,
  Normal,
  Strong,
  Strongest
}
